import React from "react"
import Navbar from "../../../Common/Components/Navbar"
import Footer from "../../../Common/Components/Footer"
import Sidebar from "../../../Sidebar/Sidebar"
import ManagerTable from "./Component/ManagerTable"


const Manager =()=>{
    return(
        <>
        <Navbar />
        <div className="d-flex mainContentArea">
            <Sidebar />
            <ManagerTable />
            
        </div>
        <Footer />
        </>
    )
}

export default Manager